import ContentMarkDown from '@/shared/ui/content-mark-down/ContentMarkDown';

interface Props {
  title: string;
  summary?: string;
  image?: string;
  imageAlt?: string;
}

const DiseaseEncyclopedia = (props: Props) => {
  return (
    <div className='flex items-center justify-between gap-[24px]'>
      <div className='flex flex-col items-baseline border border-gray-200'>
        <span className='typography-ui-17sb mb-[8px] text-left text-gray-900'>{props.title}</span>
        <span className='typography-ui-15m line-clamp-3 h-[68px] overflow-ellipsis text-left text-gray-400'>
          <ContentMarkDown
            markdown={props.summary ?? ''}
            components={{
              h2: (_node, ..._rest) => {
                return <></>;
              },
              h3: (_node, ..._rest) => {
                return <></>;
              },
              h4: (_node, ..._rest) => {
                return <></>;
              },
              p: (node, ...rest) => {
                return <p {...rest}>{node.children}</p>;
              },
            }}
          />
        </span>
      </div>
      {props.image && (
        <div className='flex max-h-[72px] min-h-[72px] min-w-[72px] max-w-[72px] items-center justify-center rounded-[8px] border border-gray-30 border-solid bg-white'>
          <img
            src={props.image}
            alt={props.imageAlt}
            className='box-border h-auto w-full rounded-[8px] object-contain'
          />
        </div>
      )}
    </div>
  );
};

export default DiseaseEncyclopedia;
